export default __webpack_public_path__ + "static/media/featured-in-4.e3326e4f.png";